import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { MantineReactTable, useMantineReactTable } from 'mantine-react-table';
import { Text } from '@mantine/core';
import { Box, Button as MButton } from '@mantine/core';
import { IconDownload } from '@tabler/icons-react';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import Button from 'react-bootstrap/Button';
import { useSelector, useDispatch } from 'react-redux'
import { useMediaQuery } from '@mantine/hooks';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logo from '../elia-logo-narrow.png';
import motlogo from '../mot-logo.png';
import tsatal from '../tsatal.png';
import useWindowDims from "../hooks/WindowDims";
import './Table.css'
import "./Rubik-Regular.js";
import "./Rubik-Bold";
import Popup from './Popup'
import { setPopup } from "../reducers/PopupSlice.js"
import uuid from "react-uuid";

import {
  faAnglesDown,
  faBars,
  faBarsStaggered,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faCircleXmark,
  faColumns,
  faCompress,
  faEdit,
  faEllipsisH,
  faEllipsisV,
  faExpand,
  faEyeSlash,
  faFilter,
  faFilterCircleXmark,
  faFloppyDisk,
  faGrip,
  faLayerGroup,
  faSearch,
  faSearchMinus,
  faSort,
  faSortDown,
  faSortUp,
  faTextWidth,
  faThumbTack,
  faX,
} from '@fortawesome/free-solid-svg-icons'; //replace free solid with your desired icon set
import '@fortawesome/fontawesome-svg-core/styles.css';
import { config } from '@fortawesome/fontawesome-svg-core';
config.autoAddCss = true;

const props = []
const fontAwesomeIcons = {
  IconArrowAutofitContent: (props) => (
    <FontAwesomeIcon icon={faTextWidth} color="#325d88"  {...props} />
  ),
  IconArrowsSort: (props) => <FontAwesomeIcon icon={faSort} color="#325d88" {...props} />,
  IconBoxMultiple: (props) => (
    <FontAwesomeIcon icon={faLayerGroup} color="#325d88"  {...props} />
  ),
  IconChevronDown: (props) => (
    <FontAwesomeIcon icon={faChevronDown} color="#325d88" {...props} />
  ),
  IconChevronLeft: (props) => (
    <FontAwesomeIcon icon={faChevronLeft} color="#325d88" {...props} />
  ),
  IconChevronRight: (props) => (
    <FontAwesomeIcon icon={faChevronRight} color="#325d88" {...props} />
  ),
  IconChevronsDown: (props) => (
    <FontAwesomeIcon icon={faAnglesDown} color="#325d88" {...props} />
  ),
  IconCircleX: (props) => <FontAwesomeIcon icon={faCircleXmark} color="#325d88" {...props} />,
  IconClearAll: (props) => (
    <FontAwesomeIcon icon={faBarsStaggered} color="#325d88" {...props} />
  ),
  IconColumns: (props) => <FontAwesomeIcon icon={faColumns} color="#325d88" {...props} />,
  IconDeviceFloppy: (props) => (
    <FontAwesomeIcon icon={faFloppyDisk} color="#325d88" {...props} />
  ),
  IconDots: (props) => <FontAwesomeIcon icon={faEllipsisH} color="#325d88" {...props} />,
  IconDotsVertical: (props) => (
    <FontAwesomeIcon icon={faEllipsisV} color="#325d88"{...props} />
  ),
  IconEdit: (props) => <FontAwesomeIcon icon={faEdit} color="#325d88" {...props} />,
  IconEyeOff: (props) => <FontAwesomeIcon icon={faEyeSlash} color="#325d88" {...props} />,
  IconFilter: (props) => <FontAwesomeIcon icon={faFilter} color="#325d88" {...props} />,
  IconFilterOff: (props) => (
    <FontAwesomeIcon icon={faFilterCircleXmark} color="#325d88" {...props} />
  ),
  IconGripHorizontal: (props) => <FontAwesomeIcon icon={faGrip} color="#325d88"{...props} />,
  IconMaximize: (props) => <FontAwesomeIcon icon={faExpand} color="#325d88" {...props} />,
  IconMinimize: (props) => <FontAwesomeIcon icon={faCompress} color="#325d88"{...props} />,
  IconPinned: (props) => <FontAwesomeIcon icon={faThumbTack} color="#325d88"{...props} />,
  IconPinnedOff: (props) => <FontAwesomeIcon icon={faThumbTack} color="#325d88"{...props} />,
  IconSearch: (props) => <FontAwesomeIcon icon={faSearch} color="#325d88" {...props} />,
  IconSearchOff: (props) => <FontAwesomeIcon icon={faSearchMinus} color="#325d88"{...props} />,
  IconSortAscending: (props) => <FontAwesomeIcon icon={faSortUp} color="#325d88"{...props} />,
  IconSortDescending: (props) => (
    <FontAwesomeIcon icon={faSortDown} color="#325d88"{...props} />
  ),
  IconBaselineDensityLarge: (props) => (
    <FontAwesomeIcon icon={faBars} color="#325d88" {...props} />
  ),
  IconBaselineDensityMedium: (props) => (
    <FontAwesomeIcon icon={faBars} color="#325d88" {...props} />
  ),
  IconBaselineDensitySmall: (props) => (
    <FontAwesomeIcon icon={faBars} color="#325d88" {...props} />
  ),
  IconX: (props) => <FontAwesomeIcon icon={faX} color="#325d88"{...props} />,
};



const Table = () => {
  // const item = useSelector((state) => state.item.value)
  const popup = useSelector((state) => state.popup.value)
  const data = useSelector((state) => state.data.value)
  const item = useSelector((state) => state.item.value)
  const param = useSelector((state) => state.param.value)
  const { width, height } = useWindowDims();
  const [colSize, setColSize] = useState(width / 5);
  const [maxColSize, setMaxColSize] = useState(width / 5);
  const [minColSize, setMinColSize] = useState(10);
  const [colSizeHotel, setColSizeHotel] = useState(width / 15);
  const [maxColSizeHotel, setMaxColSizeHotel] = useState(width / 15);
  const [minColSizeHotel, setMinColSizeHotel] = useState(10);
  const [columnPinning, setColumnPinning] = useState({});
  const isDesktop = useMediaQuery('(min-width: 1200px)');
  const dispatch = useDispatch()



  useEffect(() => {
    if (width < 1000) {
      setMaxColSizeHotel(width / 5)
      setColSizeHotel(width / 5)
      setMaxColSize(width / 5)
      setColSize(width / 5)
    }
    else {
      setMaxColSizeHotel(width * 0.5 / 15)
      setColSizeHotel(width * 0.5 / 15)
      setMaxColSize(width * 0.5 / 5)
      setColSize(width * 0.5 / 5)

    }




  }, [width])

  useEffect(() => {
    setColumns([

      {

        accessorKey: "מלון",
        header: `מלון`,
        enableSorting: true,
        minSize: minColSizeHotel,
        maxSize: maxColSizeHotel,
        mantineTableHeadCellProps: {sx: { minSise:1000,textAlign: "right" }, },
        enableResizing: true,
        enableColumnDragging: false,
        size: colSizeHotel,

        textAlign: "center",


        mantineTableBodyCellProps: ({ cell, row }) => (row.original.id_ == 0 ? {
          className: 'row-head',
          rowSpan: 1,
          colSpan: 1,
          style: {
            // backgroundColor:"#c6dbef",
            color: "#08519c",
            fontStyle: "italic",
            // borderBottom: "0.1rem solid #c6dbef"
          }

        } : {
          colSpan: 1,
          rowSpan: 1,
          style: {
            display: false,
            show: false,
            // visibility:"hidden"
          }

        }),
        Cell: ({ cell }) => (cell.row.original.id_ === 0 ?
          <>
            {cell.getValue()}
          </>

          : <>

          </>),



      },
      {

        accessorKey: "תחנות תחבורה ציבורית בקרבת המלון",
        header: "תחנות תחבורה ציבורית בקרבת המלון",
        enableSorting: false,
        minSize: minColSizeHotel,
        maxSize: maxColSizeHotel,
        mantineTableHeadCellProps: {sx: { height:"15vhe",textWrap: "wrap" }},
        enableResizing: true,
        enableColumnDragging: false,
        size: colSizeHotel,

        textAlign: "center",

        

        mantineTableBodyCellProps: ({ cell, row }) => (row.original.id_ == 0 ? {
          className: 'row-head',
          rowSpan: 1,
          colSpan: 1,
          style: {
            // backgroundColor:"#c6dbef",
            color: "#08519c",
            fontStyle: "italic",
            // borderBottom: "0.1rem solid #c6dbef"
          }

        } : {
          colSpan: 1,
          rowSpan: 1,
          style: {
            display: false,
            show: false,
            // visibility:"hidden"
          }

        }),
        Cell: ({ cell }) => (cell.row.original.id_ === 0 ?
          <>
               
         { cell.getValue().split("–").map((d)=>{
           return  <Box key={uuid()}>{d==""?'':'\u2022 ' +d} <br/></Box>
         
         })}
          </>

          : <>

          </>),

      },

      {

        accessorKey: 'יעד',
        header: 'יעד',
        minSize: minColSizeHotel,
        maxSize: maxColSizeHotel,
        size: colSizeHotel,
        enableResizing: true,
        enableSorting: false,
        enableColumnDragging: false,
        mantineTableHeadCellProps: {sx: { height:"15vhe",textWrap: "wrap" }},
        size: colSize,
        textAlign: "right",
        colSpan: 1,
        rowSpan: 1,
       

      }
      , {

        accessorKey: "דרכי הגעה בתחבורה ציבורית",
        header: "דרכי הגעה בתחבורה ציבורית",

        minSize: minColSize,
        maxSize: maxColSize,
        size: colSize,
        enableColumnActions: false,
        enableColumnDragging: false,
        enableColumnFilter: false,

        enableSorting: false,

        textAlign: "right",
        colSpan: 1,
        rowSpan: 1,
        Cell: ({ cell }) => 
      <>
         
         { cell.getValue().split("-").map((d)=>{
           return  <Box key={uuid()}>{d==""?'':'\u2022 ' +d} <br/></Box>
         
         })}
        </>

       


      }])
  }, [colSize, maxColSize, minColSize, colSizeHotel, maxColSizeHotel, minColSizeHotel]
  )

   const switchPar=(s)=>{

    return s.replace(")", "@@").replace("(", ")").replace("@@", "(")
   }

   const breakLine=(s)=>{
    let out = s.split(" - ").map(d=>d).join('\u2022 ' )
    out = out.split("- ").map(d=>d).join('\u2022 ' )
    out = out.split("- ").map(d=>d).join('\u2022 ' )
    out = out.split("-").map(d=>d).join('\u2022 ' )
    out = out.split(" – ").map(d=>d).join('\u2022 ' )
    out = out.split("– ").map(d=>d).join('\u2022 ' )
    out = out.split(" –").map(d=>d).join('\u2022 ' )
    out = out.split("–").map(d=>d).join('\u2022 ' )
    return out
   }

  const handleExportRows = (e, rows) => {
    let doc = new jsPDF();
    doc.addFont("Rubik-Regular.ttf", "Rubik", "normal");
    doc.addFont("Rubik-Bold.ttf", "Rubik", "bold");
    doc.setFont("Rubik", "normal"); // set font
    doc.setFontSize(12);
    doc.setR2L(true);


    const tableDataAlt = []
    const hotels = []

    rows.map((row) => {
      if (row.original.id_ == 0 ) {
        hotels.push(row.original["מלון"])
        tableDataAlt.push(
          [
            { content:  breakLine(switchPar(row.original["דרכי הגעה בתחבורה ציבורית"])), colSpan: 1, rowSpan: 1, styles: { cellWidth: 100 } },
            { content: switchPar(row.original["יעד"]), colSpan: 1, rowSpan: 1, styles: { cellWidth: 25 } },
            {
              content: breakLine(switchPar(row.original["תחנות תחבורה ציבורית בקרבת המלון"])), colSpan: 1, rowSpan: row.original["count"],
              styles: { cellWidth: 30 }
            },
            { content: switchPar(row.original["מלון"]), colSpan: 1, rowSpan: row.original["count"], styles: { cellWidth: 25 } },
          ]
        )
      }
      else  {
        tableDataAlt.push(
          [
            { content:  breakLine(switchPar(row.original["דרכי הגעה בתחבורה ציבורית"])), colSpan: 1, rowSpan: 1 },
            { content: switchPar(row.original["יעד"]), colSpan: 1, rowSpan: 1 },
          ]
        )
      }

    });
    const tableHeadersAlt = ["דרכי הגעה בתחבורה ציבורית", "יעד", "תחנות תחבורה ציבורית בקרבת המלון", "מלון"]
    doc.addImage(motlogo, 'png', 75, 5, 30, 15)
    doc.addImage(tsatal, 'png', 110, 5, 15, 15)
    doc.setFontSize(16);
    doc.setFont("Rubik", "bold");
    if (hotels.length < 5) {

      doc.text(`תחבורה ציבורית בקרברת בתי המלון  ${hotels.join(", ")}`, 190, 40, { align: "right" });

    }
    else {
      doc.text(`תחבורה ציבורית בקרבת בתי מלון ב${param}`, 190, 40, { align: "right", maxWidth: 175 });

    }

    doc.setFontSize(14);
    doc.text(`מידע כללי על התחבורה הציבורית בירושלים`, 190, 47.5, { align: "right", maxWidth: 175 });
    doc.setFontSize(13);
    doc.text('\u2022  ' + `כיצד ניתן לשלם על נסיעה בשירות התחבורה הציבורית בירושלים?`, 190, 55, { align: "right", maxWidth: 175 });
    doc.setFontSize(12);
    doc.setFont("Rubik", "normal");
    doc.text(`ברב קו טעון מראש בחוזה מתאים או באפליקציות כגון מוביט, פנגו, רב פס וסלו. לא ניתן לרכוש כרטיסים במזומן על גבי האוטובוס או בתוך קרונות הרכבת הקלה. לתשומת ליבכם, התשלום ברכבת הקלה באמצעות האפליקציה הינו מבוסס מיקום, לא נדרשת בחירת תחנת עליה או סריקת QR. תשלום עבור נסיעה בירושלים כוללת גם מעבר חופשי עד 90 דקות.`,
      190, 60, { align: "right", maxWidth: 175, lineHeightFactor: 1.5 });
    doc.setFont("Rubik", "bold");
    doc.setFontSize(13);
    doc.text('\u2022  ' + `כיצד ניתן לקבל מידע על תחבורה ציבורית סדירה?`, 190, 85, { align: "right", maxWidth: 175 });
    doc.setFont("Rubik", "normal");
    doc.setFontSize(12);
    doc.text(`מרכז השירות הארצי לתחבורה ציבורית בטלפון 8787*, באתר האינטרנט bus.gov.il וביישומוני המידע כגון מוביט ואיפה בוס. לקבלת זמני נסיעה בזמן אמת כנסו ליישומוני המידע.`,
     190, 90, { align: "right", maxWidth: 175 });
     doc.setFontSize(9);
    doc.text(`*  המידע מעודכן לתאריך 29.10.23. קווים לא פעילים נכון ל-25.10.23 שלא מופיעים בטבלה: 2. קו 97 פועל עד השעה 20:00 בלבד. מוצגות חלופות נסיעה עיקריות בלבד מהמלון אל היעד, ייתכנו שינויים בכיוון הנגדי.`,
    190, 102.5, { align: "right", maxWidth: 170 })

    autoTable(doc, {
      startY: 120,
      pageBreak: 'avoid',
      head: [tableHeadersAlt],
      body: tableDataAlt,
      styles: {
        font: "Rubik",
        halign: 'right',
        isSymmetricSwapping: true,
        isInputVisual: true,
        isOutputVisual: false,
      }
    });
    console.log("saving fil")
    doc.save('hotels.pdf')
    doc = null;
    return null
  };


  const [columns, setColumns] = useState([

    {

      accessorKey: "מלון",
      header: `מלון`,
      enableSorting: true,
      minSize: minColSizeHotel,
      maxSize: maxColSizeHotel,
      mantineTableHeadCellProps: {sx: { minSise:1000,textAlign: "right" }, },
      enableResizing: true,
      enableColumnDragging: false,
      size: colSizeHotel,

      textAlign: "center",

      Cell: ({ cell }) => (cell.row.original.id_ === 0 ?
        <>
          {cell.getValue()}
        </>

        : <>

        </>),

      mantineTableBodyCellProps: ({ cell, row }) => (row.original.id_ == 0 ? {
        className: 'row-head',
        rowSpan: row.original.count,
        colSpan: 1,
        style: {
          // backgroundColor:"#c6dbef",
          color: "#08519c",
          fontStyle: "italic",
          // borderBottom: "0.1rem solid #c6dbef"
        }

      } : {
        colSpan: 1,
        rowSpan: 1,
        style: {
          display: false,
          show: false,
          // visibility:"hidden"
        }

      }),
    


    },
    {

      accessorKey: "תחנות תחבורה ציבורית בקרבת המלון",
      header: "תחנות תחבורה ציבורית בקרבת המלון",
      enableSorting: true,
      minSize: minColSizeHotel,
      maxSize: maxColSizeHotel,
      // mantineTableHeadCellProps: {sx: { minSise:1000 }},
      enableResizing: true,
      enableColumnDragging: false,
      size: colSizeHotel,
      mantineTableHeadCellProps: {sx: { minSise:1000,textAlign: "right" }, },
      textAlign: "center",
      Cell: ({ cell }) => (cell.row.original.id_ === 0 ?
        <>
             
       { cell.getValue().split("-").map((d)=>{
         return  <div key={uuid()}>{d==""?'':'\u2022 ' +d} <br/></div>
       
       })}
        </>

        : <>

        </>),
      mantineTableBodyCellProps: ({ cell, row }) => (row.original.id_ == 0 ? {
        className: 'row-head',
        rowSpan: 1,
        colSpan: 1,
        style: {
          // backgroundColor:"#c6dbef",
          color: "#08519c",
          fontStyle: "italic",
          // borderBottom: "0.1rem solid #c6dbef"
        }

      } : {
        colSpan: 1,
        rowSpan: 1,
        style: {
          display: false,
          show: false,
        
        }

      }),
    

    },
    {

      accessorKey: 'יעד',
      header: 'יעד',
      minSize: minColSizeHotel,
      maxSize: maxColSizeHotel,
      size: colSizeHotel,
      enableResizing: true,
      enableSorting: true,
      enableColumnDragging: false,

      size: colSize,
      textAlign: "right",
      



    }
    , {

      accessorKey: "דרכי הגעה בתחבורה ציבורית",
      header: "דרכי הגעה בתחבורה ציבורית",

      minSize: minColSize,
      maxSize: maxColSize,
      size: colSize,
      enableColumnActions: false,
      enableColumnDragging: false,
      enableColumnFilter: false,

      enableSorting: false,

      textAlign: "right",
   

    }
  ])

  const [rows, setRows] = useState(
    {
      ["מלון"]: '',
      ["stops"]: '',
      ["יעד"]: '',
      ["דרכי הגעה בתחבורה ציבורית"]: ''

    }
  )

  const tableContainerRef = useRef(null);

  useEffect(() => {
    if (Object.keys(data[0]).length>0){

    const output = [];
    const tableData = item.data.length>0?item.data:data[0][param]

    tableData.map((hotel) => {
      const name = hotel.name 
      const stops = hotel.stops
      const destinations = Object.fromEntries(Object.entries(hotel.destinations).filter(([_, v]) => { return v != null && v != '' }));
      if (Object.keys(destinations).length > 0) {


        Object.keys(destinations).map((dest, i) => {
          if (i == 0) {
            output.push({

              ["id_"]: i,
              ["count"]: Object.keys(destinations).length,

              ["מלון"]: name,
              ["תחנות תחבורה ציבורית בקרבת המלון"]: stops,
              ["יעד"]: dest,
              ["דרכי הגעה בתחבורה ציבורית"]: destinations[dest],

            })
    
          }

          else {
            output.push({

              ["id_"]: i,
              ["count"]: Object.keys(destinations).length,
              ["מלון"]: name,

              ["תחנות תחבורה ציבורית בקרבת המלון"]: stops,
              ["יעד"]: dest,
              ["דרכי הגעה בתחבורה ציבורית"]: destinations[dest],
            })

          }

        })
      } else {
        output.push({

          ["id_"]: 0,
          ["count"]:1,

          ["מלון"]: name,
          ["תחנות תחבורה ציבורית בקרבת המלון"]: stops,
          ["יעד"]: '',
          ["דרכי הגעה בתחבורה ציבורית"]: '',

        })

      }


    })

    setRows(output.flat())
  }

  }, [data, item, param])

  useEffect(() => {
    if (typeof window !== 'undefined') {
      if (isDesktop) {
        setColumnPinning({
          left: ['mrt-row-expand', 'mrt-row-numbers', 'cellInstanceAPI'],
          right: ['link'],
        });
      } else {
        setColumnPinning({});
      }
    }
  }, [isDesktop]);


  const table = useMantineReactTable({
    columns,
    data: rows,
    enableStickyHeader: true,
    enableStickyFooter: true,
    captionSide: "top",
    // enableExpanding: true,
    // getSubRows: (originalRow) => originalRow.subRows,

    enableColumnOrdering: true,

    // enableColumnResizing: true,
    // columnFilterDisplayMode: 'popover',
    paginationDisplayMode: 'pages',
    positionToolbarAlertBanner: 'top',
    icons: fontAwesomeIcons,
    enableGrouping: true,
    // showSearch:false,
    initialState: {
      density: 'sm',
      
      // expanded: true,
      // grouping: ['מלון'],
      sorting: [{ id: 'מלון', desc: false }],
    },


    mantinePaperProps: {
      shadow: 'none',
      sx: {
        borderRadius: '0',
       

        marginBottom: '50px',
        border: '1px dashed #e0e0e0',

      },

    },
    mantineTableProps: {
      striped: true,
    },
    mantineEditTextInputProps: ({ cell }) => ({
      disabled: cell.row.original.id_ != 0,
    }),
    mantineTableBodyCellProps: ({ cell }) => ({
      // onMouseEnter: (event) => {
      //   console.log(event)
      //   if (cell.row.depth === 0)
      //     dispatch(setPopup({
      //       show: true,
      //       x: event.pageX,
      //       y: event.pageY,
      //       data: cell.row.original,

      //     }))
      // },
      // onMouseOut: (event) => {
      //   console.log(event)
      //   if (cell.row.depth === 0)
      //     dispatch(setPopup({
      //       show: false,
      //       x: 0,
      //       y: 0,
      //       data: {},

      //     }))
      // },
    }),
    mantineTableHeadCellProps: {
      align: 'center',
      direction:"rtl"
      // textAlign: "right"
    },
    mantineToolbarAlertBannerBadgeProps: { color: 'blue', variant: 'outline' },
   

    renderTopToolbarCustomActions: ({ table }) => (
      <Box
        sx={{
          display: 'flex',
          gap: '16px',
          padding: '8px',
          flexWrap: 'wrap',
        }}
      >
        <MButton
          disabled={table.getPrePaginationRowModel().rows.length === 0}
     
          onClick={(e) =>
            handleExportRows(e, table.getPrePaginationRowModel().rows)
          }
          rightIcon={<IconDownload />}
          variant="filled"
        >
          הורד טבלה
        </MButton>

      </Box>
    ),


  },);


  return (

    <div id="table">
      <MantineReactTable table={table}
      />
      {/* {popup.show &&
                (
                     
                    <Popup data={popup}/>
                )} */}
    </div>

  )
};



export default Table;